import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginComponent } from './features/auth/components/login/login.component';
import { DashboardComponent } from './features/dashboard/components/dashboard/dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { NotificationsListComponent } from './features/notifications/components/notifications-list/notifications-list.component';
import { NotificationsCreateComponent } from './features/notifications/components/notifications-create/notifications-create.component';

const routes: Routes = [
  { 
    path: 'login', 
    component: LoginComponent 
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { 
        path: 'dashboard', 
        component: DashboardComponent 
      },
      {
        path: 'notificaciones',
        children: [
          {
            path: '',
            component: NotificationsListComponent
          },
          {
            path: 'crear',
            component: NotificationsCreateComponent
          }
        ]
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'cursos',
        loadChildren: () => import('./features/courses/courses.module').then(m => m.CoursesModule)
      },
      {
        path: 'matriculas',
        loadChildren: () => import('./features/enrollments/enrollments.module').then(m => m.EnrollmentsModule)
      },
      {
        path: 'documentos',
        loadChildren: () => import('./features/documents/documents.module').then(m => m.DocumentsModule)
      },
      {
        path: 'finanzas',
        loadChildren: () => import('./features/finances/finances.module').then(m => m.FinancesModule)
      },
      {
        path: 'financiamientos',
        loadChildren: () => import('./features/financing/financing.module').then(m => m.FinancingModule)
      },
      {
        path: 'modulos',
        loadChildren: () => import('./features/modules/modules.module').then(m => m.ModulesModule)
      },
      {
        path: 'servicios',
        loadChildren: () => import('./features/services/services.module').then(m => m.ServicesModule)
      },
      { 
        path: '', 
        redirectTo: 'dashboard', 
        pathMatch: 'full' 
      }
    ]
  },
  { 
    path: '**', 
    redirectTo: 'dashboard' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
